import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { SectionHead } from "@/components/site/Reveal";
import { CATEGORIES } from "@/data/site";

const SPANS = ["md:col-span-4 md:row-span-2", "md:col-span-2", "md:col-span-2", "md:col-span-3", "md:col-span-3"];

const track = (e) => {
  const r = e.currentTarget.getBoundingClientRect();
  e.currentTarget.style.setProperty("--mx", `${e.clientX - r.left}px`);
  e.currentTarget.style.setProperty("--my", `${e.clientY - r.top}px`);
};

export const Bento = ({ onSelect }) => (
  <section className="px-6 py-28" data-testid="categories-section">
    <div className="mx-auto max-w-7xl">
      <div className="flex flex-col md:flex-row md:items-end justify-between gap-8 mb-14">
        <SectionHead eyebrow="01 / What we stock" title={["Every part your", "project needs."]} />
        <p className="max-w-sm text-[#a5b4c8] text-sm md:text-base">Over 5,000 electrical products across five core categories, from a single metre of wire to a full building's material list. Tap a category to see the brands we stock.</p>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-6 md:auto-rows-[260px] gap-4">
        {CATEGORIES.map((c, i) => (
          <motion.article key={c.id} onMouseMove={track} onClick={() => onSelect(c.id)} data-testid={`category-card-${c.id}`}
            role="button" tabIndex={0} onKeyDown={(e) => e.key === "Enter" && onSelect(c.id)}
            initial={{ opacity: 0, y: 40 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, amount: 0.15 }}
            transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1], delay: (i % 3) * 0.08 }}
            className={`spot-frame group cursor-pointer rounded-3xl border border-white/10 min-h-[300px] md:min-h-0 ${SPANS[i]}`}>
            <img src={c.img} alt={c.alt} loading="lazy" className="absolute inset-0 h-full w-full object-cover" />
            <div className="absolute inset-0 z-10 p-6 flex flex-col justify-between">
              <div className="flex justify-between items-start">
                <span className="font-mono text-[11px] tracking-[0.2em] uppercase rounded-full px-3 py-1.5 bg-[#030712]/70 backdrop-blur border border-[#39FF14]/25 text-[#39FF14]">{c.tag}</span>
                <span className="h-10 w-10 rounded-full grid place-items-center bg-white/10 backdrop-blur transition-colors duration-300 group-hover:bg-[#39FF14] group-hover:text-[#030712]"><ArrowUpRight size={18} /></span>
              </div>
              <div>
                <h3 className={`font-display font-bold ${i === 0 ? "text-3xl md:text-5xl" : "text-2xl"}`}>{c.title}</h3>
                <p className={`mt-3 text-sm text-slate-300 leading-relaxed ${i === 0 ? "max-w-md" : "line-clamp-2"}`}>{c.text}</p>
              </div>
            </div>
          </motion.article>
        ))}
      </div>
    </div>
  </section>
);
